import {
  getFormattedDate,
  getStatusDescription,
  isDateExistsInbetween
} from "../../util/helpers";
import {
  getDeclarationPlace,
  getTitle
} from "../../util/onBoardingDataFilters";

export const prevOrgCandidatesDetailsConfig = (
  candidates,
  candidateStatus,
  fromDate,
  toDate
) => {
  let filteredEmployees;

  candidateStatus = String(candidateStatus);
  filteredEmployees =
    candidates && (candidateStatus || fromDate || toDate)
      ? candidates.map(employee => {
          let isFilteredByCandidateStatus;
          let isFilteredByDates;

          if (candidateStatus && employee.status == candidateStatus) {
            isFilteredByCandidateStatus = true;
          }

          if (
            employee.userDetails?.dateofJoining &&
            isDateExistsInbetween(
              employee.userDetails.dateofJoining,
              fromDate,
              toDate
            )
          ) {
            isFilteredByDates = true;
          }

          if (
            candidateStatus &&
            (fromDate || toDate) &&
            isFilteredByCandidateStatus &&
            isFilteredByDates
          ) {
            return employee;
          } else if (
            candidateStatus &&
            !(fromDate || toDate) &&
            isFilteredByCandidateStatus
          ) {
            return employee;
          } else if (
            !candidateStatus &&
            (fromDate || toDate) &&
            isFilteredByDates
          ) {
            return employee;
          }

          return undefined;
        })
      : candidates || [];

  filteredEmployees = filteredEmployees.filter(a => a);

  const preOrgCandidatesEntries = [];
  filteredEmployees.forEach(employee => {
    if (employee.userDetails?.organizationDetails?.length) {
      const { status } = employee;
      const {
        cDKEmployeeId,
        dateofJoining,
        declarationPlace,
        firstName,
        middleName,
        lastName,
        title,
        organizationDetails
      } = employee.userDetails;
      organizationDetails.forEach(orgDetail => {
        preOrgCandidatesEntries.push({
          cDKEmployeeId,
          status,
          title,
          firstName,
          middleName,
          lastName,
          declarationPlace,
          dateofJoining,
          organization: orgDetail.organizationName,
          jobTitle: orgDetail.jobTitle,
          joiningDate: orgDetail.joiningDate,
          lastWorkingDate: orgDetail.lastWorkingDate,
          jobLocation: orgDetail.location
        });
      });
    }
  });

  return [
    {
      columns: [
        {
          title: "Employee ID",
          width: { wch: 14 }
        },
        {
          title: "Status",
          width: { wch: 14 }
        },
        {
          title: "Title(Mr/Ms)",
          width: { wch: 14 }
        },
        {
          title: "First Name",
          width: { wch: 14 }
        },
        {
          title: "Middle Name",
          width: { wch: 14 }
        },
        {
          title: "Last Name",
          width: { wch: 14 }
        },
        {
          title: "Employee Location",
          width: { wch: 14 }
        },
        {
          title: "Date Of Joining",
          width: { wch: 14 }
        },
        {
          title: "Designation",
          width: { wch: 16 }
        },
        {
          title: "Organization",
          width: { wch: 18 }
        },
        {
          title: "Start Date",
          width: { wch: 14 }
        },
        {
          title: "End Date",
          width: { wch: 14 }
        },
        {
          title: "Location",
          width: { wch: 14 }
        }
      ],
      data: preOrgCandidatesEntries.length
        ? preOrgCandidatesEntries.map(employee => {
            return [
              {
                value: employee.cDKEmployeeId || "",
                style: { font: { sz: "12" } }
              },
              {
                value: getStatusDescription(employee.status) || "",
                style: { font: { sz: "12" } }
              },
              {
                value: getTitle(employee.title) || "",
                style: { font: { sz: "12" } }
              },
              {
                value: employee.firstName || "",
                style: { font: { sz: "12" } }
              },
              {
                value: employee.middleName || "",
                style: { font: { sz: "12" } }
              },
              {
                value: employee.lastName || "",
                style: { font: { sz: "12" } }
              },
              {
                value: getDeclarationPlace(employee.declarationPlace) || "",
                style: { font: { sz: "12" } }
              },
              {
                value: getFormattedDate(employee.dateofJoining) || "",
                style: { font: { sz: "12" } }
              },
              {
                value: employee.jobTitle || "",
                style: { font: { sz: "12" } }
              },
              {
                value: employee.organization || "",
                style: { font: { sz: "12" } }
              },
              {
                value: getFormattedDate(employee.joiningDate) || "",
                style: { font: { sz: "12" } }
              },
              {
                value: getFormattedDate(employee.lastWorkingDate) || "",
                style: { font: { sz: "12" } }
              },
              {
                value: employee.jobLocation || "",
                style: { font: { sz: "12" } }
              }
            ];
          })
        : []
    }
  ];
};
